import PropTypes from 'prop-types'
import { Logo } from "../../Logo";
import { Grid, Typography, Button, Stack } from "@mui/material";

const WizardHeader = (props) => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="flex-start"
      spacing={0}
    >
      <>
        <Logo />
      </>
      <>
        <Typography align="left" variant="h4">
        {props.title} 
        </Typography>
      </>
    </Stack>
  );
};

WizardHeader.propTypes = {
  title: PropTypes.any 
};

export default WizardHeader;


